import React, { useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import { Zoom } from "yet-another-react-lightbox/plugins";

const Gallery = props => {

  const [active, setActive] = useState(false);

  function getRandomTime() {
    // Random hour from 1 to 12
    const hour = Math.floor(Math.random() * 12) + 1;

    // Random minute from 0 to 59
    const minute = Math.floor(Math.random() * 60);

    // Format with leading zeros where needed
    const hourStr = hour.toString();
    const minuteStr = minute.toString().padStart(2, '0');

    return `${hourStr}:${minuteStr}`;
  }

  return (
    <>
      <Lightbox
        open={!!active}
        index={active - 1}
        close={() => setActive(false)}
        slides={props.work.focus.gallery.map(img => ({src: `img/projects/${props.work.slug}/focus/${img}`}))}
        plugins={[Zoom]}
      />
      <section className={`gallery ${props.work.focus?.gallerySpaced ? "spaced" : ""}`} data-light={!!props.work.focus?.galleryLight} data-phone={!!props.work.focus?.galleryPhone}>
        <div className={`inner-gallery`}>
          {props.work.focus.gallery.map((ima, i) =>
            <div key={i} onClick={() => setActive(i+1)} role={"button"}>
              {props.work.focus?.galleryPhone &&
                <div className="phone-topbar">
                  <h5>{getRandomTime()}</h5>
                  <div className="item-row">
                    <h5>●</h5>
                    <h5>◆</h5>
                    <h5>■</h5>
                  </div>
                </div>
              }
              <img src={`img/projects/${props.work.slug}/focus/${ima}`} />
              {props.work.focus?.galleryPhone && <div className="phone-bottombar"><span /></div>}
            </div>
          )}
        </div>
      </section>
    </>
  )
}

export default Gallery;